export const RISK_STATUS_LABELS: Record<string, string> = {
  OPEN: 'Open',
  ASSESSING: 'Open',
  PENDING_REVIEW: 'Assessment',
  IN_PROGRESS: 'Treatment',
  CLOSED: 'Closed',
  MONITORING: 'Monitoring',
}

/** Risk status and treatment labels, shared by the risk register and the Auditor Center. */
export function StatusBadge({ status }: { status: string }) {
  const styles: Record<string, string> = {
    OPEN: 'bg-status-red-bg text-status-red',
    ASSESSING: 'bg-status-red-bg text-status-red',
    PENDING_REVIEW: 'bg-status-orange-bg text-status-orange',
    IN_PROGRESS: 'bg-status-blue-bg text-status-blue-strong',
    CLOSED: 'bg-status-green-bg text-status-green',
    MONITORING: 'bg-status-orange-bg text-status-orange',
  }
  return (
    <span
      className={`font-body inline-flex h-5 items-center rounded-sm px-2 text-[11px] font-medium whitespace-nowrap ${styles[status] ?? 'bg-muted text-muted-foreground'}`}
    >
      {RISK_STATUS_LABELS[status] ?? status}
    </span>
  )
}

export function TreatmentLabel({ treatment, className = 'text-[11px] text-muted-foreground' }: { treatment: string; className?: string }) {
  const labels: Record<string, string> = {
    MITIGATE: 'Mitigate',
    ACCEPT: 'Accept',
    TRANSFER: 'Transfer',
    AVOID: 'Avoid',
  }
  return (
    <span className={`font-body ${className}`}>
      {labels[treatment] ?? treatment}
    </span>
  )
}
